import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { getPayment } from '../../actions/dataActions'
import { setPaymentModal } from '../actions/modalActions'
import { getPaymentAmount, startPaymentDevice, abortPayment } from '../../functions/PaymentFunctions'
import Modal from 'react-modal'
import * as properties from '../../constants/Properties'
import Ink from 'react-ink';
import * as types from '../../constants/Types'
import * as resource from '../../constants/Resources'
import { getTranslation } from '../../actions/dataActions'

const PaymentModal = props => {
    const [showCancelAfterTimer, setShowCancelAfterTimer] = useState(false);

    const {
        paymentDevice,
        paymentModal,
        posType,
        abortPayment,
    } = props;

    useEffect(() => {
        let timer;
        if (paymentModal.show) {
            setShowCancelAfterTimer(false);
            timer = setTimeout(() => {
                setShowCancelAfterTimer(true);
            }, 45000); // 45 seconds
        } else {
            setShowCancelAfterTimer(false);
        }

        return () => {
            if (timer) {
                clearTimeout(timer);
            }
        };
    }, [paymentModal.show]);

    const payment = props.getPayment(paymentDevice.paymentid);
    const header = `${props.getTranslation(resource.PAY)}${(payment !== null ? ` ${payment.Description}` : '')}`;
    const isKiosk = (
        posType === types.POSTYPE_CHARGINGKIOSK ||
        posType === types.POSTYPE_ORDERKIOSK ||
        posType === types.POSTYPE_SALESKIOSK ||
        posType === types.POSTYPE_PRODUCTIONKIOSK
    );

    const enableStop = !isKiosk && (!payment || payment.DisableCancel !== true);
    const isPaymentFailed = !paymentDevice.busy && paymentDevice.paymentid > 0;
    const showCancel = enableStop || showCancelAfterTimer || isPaymentFailed;

    return (
        <Modal className='paymentModal'
            contentLabel=""
            isOpen={paymentModal.show}
            style={properties.paymentModalStyle}
        >
            <div className="paymentModal_header">
                <div className="header_top">
                    {header}
                </div>
            </div>

            <div className="paymentModal_content">
                {paymentDevice.status}
            </div>
            <div className="paymentModal_footer">
                {(showCancel ? <button className="btnCancel" onClick={() => abortPayment(paymentDevice.paymentid)} >
                    {props.getTranslation(resource.CANCEL)}
                    <Ink />
                </button> : (null))}
            </div>
        </Modal>
    )
}

function mapStateToProps(state) {
    return {
        paymentModal: state.modalState.paymentModal,
        paymentDevice: state.receiptState.receipt.paymentdevice,
        posType: state.generalState.posType,

    }
}

export default connect(mapStateToProps, {
    getPayment,
    setPaymentModal,
    abortPayment,
    getPaymentAmount,
    startPaymentDevice,
    getTranslation
})(PaymentModal)


// WEBPACK FOOTER //
// src/modal/components/PaymentModal.jsx